import axios from 'axios';
import { getToken, clearAuth } from '../utils/auth';

// 모든 API 호출의 공통 설정을 가진 axios 인스턴스.
// baseURL, 헤더, 인터셉터를 한 곳에서 관리.
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // refresh token 쿠키를 위한 옵션
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터: 모든 요청에 access_token을 Authorization 헤더로 자동 첨부.
apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 응답 인터셉터: 401 응답이 오면 토큰을 정리하고 로그인 페이지로 보낼 수 있도록 처리.
// (실제 페이지 이동은 호출 측에서 하는 게 깔끔하지만, 토큰 정리는 여기서 일관되게 처리)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuth();
    }
    return Promise.reject(error);
  },
);

export default apiClient;
